import { render, staticRenderFns } from "./NewPayment.vue?vue&type=template&id=35d80d2d&"
import script from "./NewPayment.vue?vue&type=script&lang=ts&"
export * from "./NewPayment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports